
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Popup from 'vux/src/components/popup/index.vue'
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'

import divSpan from '@/components/DivSpan';
export default {
name:"dynamic-form-done",
directives: {
TransferDom
},
components: {
Checker,
CheckerItem,
Popup,
divSpan
},
data() {
return {
token: '',
wrapperHeight: 0,
contentList: [],
placeholder: '',
searchData: '',
allLoaded: false,
topSearch: {},
dynamicFormCode: '',
isRequisitionFlow: false,
componentConfig: {},
dynamicFormConfig: {},
pageRules: {
direction: '' || 'DESC', // 排序
fromClientType: 'pc',
number: 0, // 当前页
property: '' || 'createdDate', // 排序字段
rules: [],
size: 15, //当前页数据多少条
specialConditions: [],
workflowSearchBean: '',
dynamicFormCode: '',
ignoreField: true,
},
url: '',
diyUrl: false,
cardConfig: [],
totalPages: 0,
id: '',
tabList:[{name:'我的待办',code:'0'},{name:'我的已办',code:'1'}],
tabField:'',
searchObj:{},
appConfig:{
"topSearch": {
"searchName": "title",
"option": "LIKE_ANYWHERE",
"placeholder": "流程标题",
"searchScope": "WORKFLOW"
},
"cardConfig": {
"topTitle": {
"valueField": "title",
"name": "流程标题-"
},
"status":{
"valueField":"workflowNodeBase.nodeName"
},
"content": [
{
"icon": "icon-supply",
"name": "创建人-",
"valueField": "createName"
},
{
"icon": "icon-all",
"name": "创建时间-",
"valueField": "createdDate",
"type":"date"
}
]
}
}
}
},
methods: {
getListData(e) {
this.$loadingShow();
this.$post(this.url, this.pageRules).then(info => {
this.totalPages = info['totalPages'];
if (e == 'top') {
this.contentList = JSON.parse(JSON.stringify(info['content']));
this.$refs.loadmore.onTopLoaded();
} else if (e == 'bottom') {
this.contentList = this.contentList.concat(info.content);
this.contentList = JSON.parse(JSON.stringify(this.contentList));
this.$refs.loadmore.onBottomLoaded();
} else {
this.contentList = JSON.parse(JSON.stringify(info['content']));
}
this.$loadingHide();
}).catch(() => {
this.$loadingHide();
});
},
getMiddleSearchCriteria() {
if (!this.dynamicFormConfig['appConfig']){
this.dynamicFormConfig['appConfig'] = this.appConfig;
}
if(this.dynamicFormConfig['appConfig']['cardConfig']){
this.cardConfig = this.dynamicFormConfig['appConfig']['cardConfig'];
}
if(this.dynamicFormConfig['appConfig']['topSearch']){
this.topSearch = this.dynamicFormConfig['appConfig']['topSearch'];
}
},
onItemClick(e) {
this.pageRules.number = 0;
this.pageRules.workflowSearchBean['searchType'] = e;
this.getListData();
},
init: function () {

if (this.$store.state.device === 'wap') {
this.wrapperHeight =
document.documentElement.clientHeight -
this.$refs.wrapper.getBoundingClientRect().top;
} else {
this.wrapperHeight =
document.documentElement.clientHeight -
this.$refs.wrapper.getBoundingClientRect().top;
}
},
clear() {
this.searchData = '';
},
searchConfirm() {
if(this.topSearch.searchScope === "WORKFLOW"){
this.pageRules.workflowSearchBean[this.topSearch['searchName']] = this.searchData;
}else{
this.pageRules.rules = this.pageRules.rules.filter(info => info['field'] != this.topSearch['searchName']);
if (this.searchData) {
const obj = {
field: this.topSearch['searchName'],
option: this.topSearch['option'],
values: [this.searchData],
collectIndex: this.topSearch['collectIndex'] || -1
};
this.pageRules.rules.push(JSON.parse(JSON.stringify(obj)));
}
}
this.getListData();
},
loadTop() {
this.pageRules.number = 0;
this.getListData('top');
},
loadBottom() {
if (this.totalPages <= this.pageRules.number + 1) {
this.$vux.toast.text('已获取全部');
this.$refs.loadmore.onBottomLoaded();
return;
}
this.pageRules.number++;
this.getListData('bottom');
},
openFlow(e) {
this.$router.push(`/workflow/${e.requestId}`);








},

getQueryString() {
let name, value;
let str = location.href;  
let num = str.indexOf('?');
str = str.substr(num + 1); 

let arr = str.split('&'); 
for (let i = 0; i < arr.length; i++) {
num = arr[i].indexOf('=');
if (num > 0) {
name = arr[i].substring(0, num);
value = arr[i].substr(num + 1);
this[name] = value;
}
}
},
conversionName(data, name) {
let retanData = '';
if (name) {
let colName = name.split('.');
if (data.hasOwnProperty(colName[0])) {
if (colName.length > 1) {
for (let i = 0; i < colName.length; i++) {
if (i == 0) {
retanData = data[colName[0]];
} else {
if (retanData != null) {
retanData = retanData[colName[i]];
} else {
return retanData = '';
}
}
}
return retanData == null ? '' : retanData;
} else {
return data[colName[0]] == null ? '' : data[colName[0]];
}
} else {
return retanData == null ? '' : retanData;
}
} else {
return retanData == null ? '' : retanData;
}
},
goBack(){
this.$router.go(-1);
}
},
created() {
let winParm = new this.getQueryString();
if (winParm['dynamicFormCode']) {
this.dynamicFormCode = winParm['dynamicFormCode'];
} else {
this.dynamicFormCode = this.$route.params['dynamicFormCode'];
}
if (this.dynamicFormCode) {
const code = this.dynamicFormCode;
this.$get(`api/component-config/name/${code}`).then((data) => {
this.componentConfig = data;
this.dynamicFormConfig = JSON.parse(this.componentConfig.configData);
this.pageRules.dynamicFormCode = this.dynamicFormCode;
this.pageRules.property = this.dynamicFormConfig.property;
this.pageRules.fixedRule = this.dynamicFormConfig['fixedRule'];
this.pageRules.workflowSearchBean = this.dynamicFormConfig['workflowSearchBean'] || undefined;
this.url = this.dynamicFormConfig['url'] || 'api/workflowRequestBase/request';
this.diyUrl = this.dynamicFormConfig['diyUrl'];
this.pageRules.ignoreField = this.dynamicFormConfig['ignoreField'];
this.pageRules = JSON.parse(JSON.stringify(this.pageRules));
if (!this.diyUrl) {
this.url = this.url + '/page';
}
this.getListData();
this.getMiddleSearchCriteria();
}).catch(() => {
this.pageRules.workflowSearchBean = {searchType: "0", workflowId:this.dynamicFormCode};
this.url = this.dynamicFormConfig['url'] || 'api/workflowRequestBase/request';
this.diyUrl = this.dynamicFormConfig['diyUrl'];
this.pageRules.ignoreField = this.dynamicFormConfig['ignoreField'];
this.pageRules = JSON.parse(JSON.stringify(this.pageRules));
if (!this.diyUrl) {
this.url = this.url + '/page';
}
this.getListData();
this.getMiddleSearchCriteria();
})
}else if(!!winParm['isRequisitionFlow']){
this.isRequisitionFlow = winParm['isRequisitionFlow'];
this.pageRules.workflowSearchBean = {searchType: "0"};
this.pageRules.property = "id";
this.url = 'api/purRequisitionSap/flow/page';
this.getListData();
this.getMiddleSearchCriteria();
}
},
mounted() {
let tokens = localStorage.getItem('_token');
if(tokens){
this.token = tokens.substr(7);
}
setTimeout(() => {
this.init();
},600);
}
}



// WEBPACK FOOTER //
// ./src/page/dynamic-form-list/dynamic-form-done.vue